import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {CelluleTableauDTO} from '../../core/dtos/gestionmenus/planning/cellule-tableau-dto';
import {PreferencesUtilisateurService} from '../../core/services/preferences-utilisateur.service';
import {UtilsService} from '../../core/utils/utils.service';
import {USER_PREFERENCE} from '../../core/constants';

@Component({
  selector: 'yo-taux-de-prise-decoupagerepas',
  templateUrl: './taux-de-prise-decoupagerepas.component.html',
  styleUrls: ['./taux-de-prise-decoupagerepas.component.scss']
})
export class TauxDePriseDecoupagerepasComponent implements OnInit, OnDestroy {

  @Input() cellule: CelluleTableauDTO;

  subDisplay: Subscription;
  displayTauxDePrise: boolean = false;

  constructor(private cd: ChangeDetectorRef,
              private prefsUserSvc: PreferencesUtilisateurService,
              private utils: UtilsService) {
  }

  ngOnInit() {
    this.subscriptionDisplayTauxDePrise();
  }

  ngOnDestroy(): void {
    this.utils.unsubscribe(this.subDisplay);
  }

  subscriptionDisplayTauxDePrise = () => {
    this.subDisplay = this.prefsUserSvc.preferencesOfUser$.subscribe(item => {
      this.displayTauxDePrise = this.prefsUserSvc.getPreferenceUtilisateurBooleanValue(USER_PREFERENCE.GESTIONMENUS_DISPLAY_TAUX_DE_PRISE);
      this.cd.markForCheck();
    });
  };

  display = () => {
    if (this.displayTauxDePrise) {
      if (Object.keys(this.cellule.mapMenuComposition).length > 0) {
        return true;
      }
    }
    return false;
  };
}
